import { z } from 'zod';

import { marketMeta, marketTypes } from '../constants';
import {
	type BettingSplitsBet,
	type BettingSplitsESResult,
	type BettingSplitsMarket,
} from '../types';

export const schemaTeam = z.object({
	name: z.string(),
	shortName: z.string().optional(),
	nickName: z.string().optional(),
	badgeUrl: z.string().optional(),
});

const schemaMarket = z.object({
	betTypeId: z.number(),
	categoryName: z.string(),
	marketClassification: z.enum(marketTypes),
	marketDisplayName: z.string(),
	marketDisplayNameMap: z.object({
		uk: z.string(),
		us: z.enum(Object.keys(marketMeta) as [keyof typeof marketMeta]),
	}),
	marketGenericSequence: z.string(),
	marketId: z.number(),
	marketName: z.string(),
	marketPropType: z.string(),
	subeventName: z.string(),
	teamData: z.object({
		home: schemaTeam,
		away: schemaTeam,
	}),
});

export function extractMarket(
	result: BettingSplitsESResult,
): BettingSplitsMarket {
	const parsedMarket = schemaMarket.safeParse(result);

	if (!parsedMarket.success) {
		throw new Error(JSON.stringify(parsedMarket.error.flatten().fieldErrors));
	}

	const {
		betTypeId,
		categoryName,
		marketClassification,
		marketDisplayName,
		marketDisplayNameMap,
		marketGenericSequence,
		marketId,
		marketName,
		marketPropType,
		subeventName,
		teamData,
	} = parsedMarket.data;

	return {
		betTypeId,
		bets: [] as BettingSplitsBet[],
		categoryName,
		marketClassification,
		marketDisplayName,
		marketDisplayNameMap,
		marketGenericSequence,
		marketId,
		marketName,
		marketPropType,
		subeventName,
		teamData,
	};
}
